import React, {
  Dispatch,
  SetStateAction,
  useMemo,
  useContext,
  useEffect,
  useState,
} from "react";
import clsx from "clsx";

import { Context } from "../../../../../studentStore";
import {
  IActiveLearningIssue,
  IActiveLearningAnswers,
} from "../../../../../state";
import { IAnswer } from "../../../../../constants/active_learning";
import TextInput from "../../../../../atoms/ActiveLearning/TextInput";
import styles from "../../ActiveLearningIssue.module.scss";
import { ReactComponent as IconLive } from "../../../../../assets/images/ActiveLearning/icon_live.svg";
import hintImage03 from "../../../../../assets/images/ActiveLearning/hint/img_03.webp";

interface IActiveLearningIssue1Props {
  issue?: IActiveLearningIssue;
  answers: IActiveLearningAnswers[];
  setAnswers: Dispatch<SetStateAction<IActiveLearningAnswers[]>>;
}

export interface IAnswerToQ1 extends IAnswer {
  value: string;
}

export const Issue3 = (props: IActiveLearningIssue1Props) => {
  const { state } = useContext(Context);
  const currentIssueNo = 3;
  const question = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 1);
  }, [props.issue?.questions]);

  const [answer, setAnswer] = useState<IAnswerToQ1>({
    id: null,
    issue_no: currentIssueNo,
    question_no: question?.order_num || NaN,
    question_id: question?.id || NaN,
    value: "",
  });

  useEffect(() => {
    const targetAnswer = state.active_learning_answers.find(
      answer =>
        answer.issue_no === currentIssueNo &&
        answer.question_no === question?.order_num,
    );
    const answerFormatOfI1Q1: IAnswerToQ1 = {
      id: targetAnswer?.id || 0,
      issue_no: currentIssueNo,
      question_no: 1,
      question_id: targetAnswer?.question_id || 0,
      value: targetAnswer?.contents?.value || "",
    };
    setAnswer({ ...answerFormatOfI1Q1 });
  }, [state.active_learning_answers, question?.order_num]);

  useEffect(() => {
    const answers = props.answers.filter(
      answer =>
        !(
          answer.issue_no === currentIssueNo &&
          answer.question_no === question?.order_num
        ),
    );
    props.setAnswers([
      ...answers,
      {
        id: answer.id || null,
        issue_no: answer.issue_no,
        question_no: question?.order_num || NaN,
        question_id: question?.id || NaN,
        contents: {
          value: answer.value,
        },
      },
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [answer, question?.order_num, question?.id]);

  const changeAnswer = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setAnswer({
      id: answer.id,
      question_id: question?.id || NaN,
      question_no: question?.order_num || NaN,
      issue_no: currentIssueNo,
      value,
    });
  };

  return (
    <div className={styles.issue}>
      <div className={styles.header}>
        <span className={styles.no}>
          WORK
          {props.issue?.no && props.issue?.no < 10
            ? `0${props.issue?.no}`
            : props.issue?.no}
        </span>
        <p className={styles.title}>{props.issue?.title}</p>
        <p className={styles.read}>
          WORK02で考えた「自分だったらこうしたい」を材料に、「問い」の原型を考えてみよう。
          <br />
          「問い」は次回のLessonで具体的にしていくので、今は自分の考えたいこと/やってみたいと思ったことを素直に入力しよう。
        </p>
      </div>
      {question && (
        <TextInput value={answer.value} handleChange={changeAnswer} />
      )}
      <div className={clsx(styles.card, styles.row)}>
        <div className={styles.wrapper}>
          <div className={styles.block}>
            <p className={styles.label}>
              <IconLive />
              POINT
            </p>
            <p className={styles.title}>「問い」とは？</p>
            <p className={styles.text}>
              探究学習における「問い」とは、『「自分だったらこうしたい」を実現するためにはどうしたら良いのだろう？』という、自分が「こうしたい」「
              考えたい」「 解決したい」という想いを含んだ問いかけのこと。
              <br />
              「問い」を設定することで、自分の願いを実現するための第一歩を踏み出すことができる。
            </p>
          </div>
          <div className={styles.block}>
            <img
              className={styles.hintImage}
              src={hintImage03}
              alt="自分だったらこうしたい／「問い」"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Issue3;
